import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import React, { FC, Fragment } from 'react'
import { Box, FormControlLabel, Radio, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { useRequestItemFulfillmentStatuses } from 'hooks'
import { Skeleton } from '@mui/material'

const StyledFormControlLabel = styled(FormControlLabel)({
    padding: '6px',
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#000000',
    },
})

const StyledRadioControl = styled(Radio)({
    padding: '0px 12px 0px 0px',
})

const StyledRadio: FC<any> = (props) => {
    const { checked, label, onChange, value } = props
    return (
        <StyledFormControlLabel
            checked={checked}
            value={value}
            label={label}
            labelPlacement="end"
            control={
                <StyledRadioControl
                    icon={<Icon name="Radio" />}
                    checkedIcon={<Icon name="RadioFilled" />}
                />
            }
            onChange={onChange}
        />
    )
}

const FulfillmentStatusesFilter = () => {
    const { t } = useTranslation()
    const { data, isLoading } = useRequestItemFulfillmentStatuses()
    const [state, dispatch]: any = usePageContext()

    const onHandleChange = (e: any) => {
        const value = e.target.value
        dispatch({
            type: 'SET_PROP',
            payload: {
                key: 'fulfillmentStatus',
                value: value,
            },
        })
    }

    return (
        <Fragment>
            {isLoading ? (
                <Box paddingTop={'16px'} marginX={'24px'}>
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Box paddingTop={'16px'}>
                    {data.map((d: any) => (
                        <Box key={d} marginX={'24px'}>
                            <StyledRadio
                                label={t(`${d}`)}
                                checked={state.fulfillmentStatus === d}
                                value={d}
                                onChange={onHandleChange}
                            />
                        </Box>
                    ))}
                </Box>
            )}
        </Fragment>
    )
}

export const FulfillmentStatusFilter = () => {
    const { t } = useTranslation()

    return (
        <Card cardTitle={t('FilterByFulfillmentStatus')} collapsible>
            <FulfillmentStatusesFilter />
        </Card>
    )
}
